import AgendaItems from './AgendaItems';

export default AgendaItems;